var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isResp},_vm._l((_vm.users),function(user){return _c('rich-people-list-item',{key:user.id,attrs:{"disabled":_vm.disabled,"count":_vm.count,"resp":_vm.resp,"user":user},on:{"deleteResp":_vm.emitResp}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }